import React from 'react';

/**
 * Value 를 useRef 에 담고, 계속 업데이트 합니다.
 */
export const useRefValue = <T>(value: T) => {
  const valueRef = React.useRef(value);
  valueRef.current = value;
  return valueRef;
};
